<template>
  <div>
    <label>Velg utleieprofil(er) for datasettet</label>
    <MultiSelect
      v-model="vmodel"
      :options="getLandlordProfilesMeta"
      placeholder="Velg utleieprofiler"
      track-by="id"
      multiple
      :searchable="false"
      :show-labels="false"
      :close-on-select="false"
    >
      <template v-slot:beforeList>
        <div class="before-list">
          <button class="btn btn-outline-primary btn-sm" @click="vmodel = getLandlordProfilesMeta">Velg alle</button>
          <button class="btn btn-outline-danger btn-sm" @click="vmodel = []">Fjern valg</button>
        </div>
      </template>
      <template v-slot:selection="{ values, remove }">
        <div class="selected-list">
          <div v-if="values.length === getLandlordProfilesMeta.length">Alle profiler</div>
          <template v-else-if="values.length > 0">
            <div
              class="selected-item"
              v-for="i in Math.min(profileSelectionMaxCount, values.length)"
              :key="values[i - 1].id"
            >
              <MultiSelectSelectedItem @click:remove="remove(values[i - 1])">
                <NameInitials :name="values[i - 1].fullName" />
              </MultiSelectSelectedItem>
            </div>
            <div v-if="values.length > profileSelectionMaxCount" class="extra-count">
              <span>+{{ values.length - profileSelectionMaxCount }}</span>
            </div>
          </template>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <NameInitials :name="option.fullName" />
        {{ option.fullName }}
      </template>
    </MultiSelect>
  </div>
</template>

<script>
import NameInitials from '@/components/UI/NameInitials.vue';
import MultiSelect from 'vue-multiselect';
import MultiSelectSelectedItem from '@/components/reports/MultiSelectSelectedItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LandlordProfileSelector',

  props: {
    profileSelectionMaxCount: {
      type: Number,
      default: 3,
    },
    value: Array,
  },

  computed: {
    ...mapGetters(['getLandlordProfilesMeta']),
    vmodel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  components: {
    NameInitials,
    MultiSelect,
    MultiSelectSelectedItem,
  },
};
</script>

<style scoped lang="scss">
.selected-list {
  display: flex;
  overflow: hidden;
  align-items: center;
  margin-bottom: 8px;
  user-select: none;

  .selected-item {
    margin-right: 0.5rem;
  }
}

.extra-count {
  width: 27px;
  height: 27px;
  background-color: $gray-300;
  color: #000;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.before-list {
  padding: 0.5rem;

  > button {
    margin-right: 0.5rem;
  }
}
</style>
